import React from 'react';
import { connect, MapDispatchToPropsFunction, MapStateToPropsParam } from 'react-redux';

import { ImmutableWidgetState, IWidgetBlockComponent, IWidgetState, WidgetBlocksState } from '../WidgetBlocks/types/IWidgetBlock';
import { FireActions } from './widgetblock/actions/types';
import { customEvent, notificationDismissed } from './widgetblock/actions';

interface WidgetsState {
    widgetBlocks: WidgetBlocksState;
}

type StateProps = Pick<IWidgetBlockComponent, 'widgetModel' | 'notifications' | 'error'>;
type OwnProps = Pick<IWidgetBlockComponent, 'widgetId' | 'instanceId'>;

const WidgetBlockWrapper = (WrappedComponent: React.ComponentType<IWidgetBlockComponent>) => {
    const mapStateToProps: MapStateToPropsParam<StateProps, OwnProps, WidgetsState> = (state, ownProps) => {
        const widget = state.widgetBlocks.widgetModels.get(ownProps.widgetId!)?.get(ownProps.instanceId!);

        if (!widget) {
            return {};
        }

        const widgetModel = (widget as IWidgetState).model || (widget as ImmutableWidgetState).get?.('model');
        const notifications = (widget as IWidgetState).notifications || (widget as ImmutableWidgetState).get?.('notifications');
        const error = (widget as IWidgetState).error || (widget as ImmutableWidgetState).get?.('error');

        return { widgetModel, notifications, error };
    };

    const mapDispatchToProps: MapDispatchToPropsFunction<Partial<FireActions>, OwnProps> = (dispatch, { widgetId, instanceId }) => ({
        fireCustomEvent: (eventName, eventPayload) => {
            // console.debug(`Dispatching custom event ${eventName} with a payload of ${eventPayload}`);
            dispatch(customEvent(widgetId, instanceId, eventName, eventPayload, true));
        },
        fireNotificationDismissed: (notificationId) => {
            dispatch(notificationDismissed(widgetId, instanceId, notificationId));
        },
    });

    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
};

export default WidgetBlockWrapper;
export { WidgetsState };
